var map = {
	"./aa-b.png": 717,
	"./aa-w.png": 344,
	"./ka-b.png": 587,
	"./ka-w.png": 30,
	"./ku-b.png": 194,
	"./ku-w.png": 503,
	"./ma-b.png": 480,
	"./ma-w.png": 342,
	"./ra-b.png": 75,
	"./ra-w.png": 573,
	"./th-b.png": 847,
	"./th-w.png": 264
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;